import pages from './pages';
import urls from './utils/urls';

const routes = [

  /*
   * LANDING
   */
  {
    path: '/',
    Component: pages.landing.Brand,
  },
  {
    path: '/creators',
    Component: pages.landing.Creator,
  },
  {
    path: '/tiktok-landing',
    Component: pages.landing.TikTokLanding,
  },
  {
    path: '/:locale/tiktok-landing',
    Component: pages.landing.TikTokLanding,
  },

  /*
   * WIZARD
   */
  {
    path: '/wizard/email',
    Component: pages.wizard._01_Email,
  },
  {
    path: '/wizard/phone',
    Component: pages.wizard._02_Phone,
  },
  {
    path: '/wizard/profile',
    Component: pages.wizard._03_Profile,
  },
  {
    path: '/wizard/socials',
    Component: pages.wizard._04_Socials,
  },

  /*
   * CONTENT
   */
  {
    path: '/blog',
    Component: () => (
      <pages.contentful.EntryList
        title='Blog'
        contentType='blog'
        image={{
          field: 'featured_image',
          altField: 'featured_image_alt',
          mode: 'cover',
        }}
        link={(item) => `/blog/${item.slug}`}
      />
    ),
  },
  {
    path: '/blog/:slug',
    Component: () => (
      <pages.contentful.EntryDetail
        contentType='blog'
      />
    ),
  },
  {
    path: '/case-studies',
    Component: () => (
      <pages.contentful.EntryList
        title='Case Studies'
        contentType='case-study'
        image={{
          field: 'brand_logo',
          altField: 'brand_logo_alt',
          mode: 'contain',
        }}
        link={(item) => `/case-studies/${item.slug}`}
      />
    ),
  },
  {
    path: '/case-studies/:slug',
    Component: () => (
      <pages.contentful.EntryDetail
        contentType='case-study'
      />
    ),
  },

  /*
   * CUSTOM
   */
  {
    path: '/blog/review-analysis-by-harnessing-chatgpt-prompts',
    Component: pages.custom.ChatGPT,
  },
  {
    path: '/blog/insights-on-social-media-trends-and-tiktok-ban',
    Component: pages.custom.Survey,
  },

  /*
   * STATIC CONTENT
   */
  {
    path: '/s/:slug',
    Component: pages.contentful.StaticContent,
  },
  {
    path: '/terms-and-conditions',
    Component: () => <pages.contentful.StaticContent slug='terms-and-conditions' />,
  },
  {
    path: '/cookie-policy',
    Component: () => <pages.contentful.StaticContent slug='cookie-policy' />,
  },
  {
    path: '/privacy-policy',
    Component: () => <pages.contentful.StaticContent slug='privacy-policy' />,
  },
  {
    path: '/campaign-terms-conditions',
    Component: () => <pages.contentful.StaticContent slug='campaign-terms-conditions' />,
  },
  {
    path: '/support',
    Component: () => <pages.contentful.StaticContent slug='support' />,
  },
  {
    path: '/privacy-choices',
    Component: () => <pages.contentful.StaticContent slug='privacy-choices' />,
  },

  /*
   * USER -> PROFILE
   */
  {
    path: '/profile',
    Component: pages.user.profile.Home,
  },
  {
    path: '/edit-profile',
    Component: pages.user.profile.sections.Edit,
  },
  {
    path: '/change-picture',
    Component: pages.user.profile.sections.Media,
  },
  {
    path: '/change-address',
    Component: pages.user.profile.sections.Address,
  },
  {
    path: '/change-password',
    Component: pages.user.profile.sections.Password,
  },
  {
    path: '/privacy-settings',
    Component: pages.user.profile.sections.Privacy,
  },
  {
    path: '/email-settings',
    Component: pages.user.profile.sections.Email,
  },
  {
    path: '/social-networks',
    Component: pages.user.profile.sections.Socials,
  },

  /*
   * USER -> CAMPAIGNS
   */
  {
    path: '/campaigns',
    Component: pages.user.campaigns.Home,
  },
  {
    path: '/c',
    Component: () => <urls.Alias target='/campaigns' />,
  },

  /*
   * USER -> TAKES
   */
  {
    path: '/takes',
    Component: pages.user.products.ProductTinder,
  },
];

export default routes;